<template>
  <form class="space-y-6" @submit="onFormElementSubmit">
    <FormInputText
      id="merchant"
      name="tenantIdentifier"
      label="Merchant Identifier"
      autocomplete="off"
      required
    />

    <FormInputText
      id="email"
      name="email"
      type="email"
      autocomplete="email"
      required
      label="Email Address"
    />

    <FormInputPassword
      id="password"
      name="password"
      label="Password"
      required
      autocomplete="current-password"
    />

    <div class="flex justify-end">
      <FormSubmitButton
        :is-submitting="isSubmitting"
        type="submit"
      >
        Sign in with password
      </FormSubmitButton>
    </div>
  </form>

  <UserInactiveAlert ref="userInactiveAlertRef" />
</template>

<script setup lang="ts">
import { logInBasic } from "@/services/auth/logInBasic"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { ApiError } from "@/api"
import type UserInactiveAlert from "@/components/UserInactiveAlert.vue"

const router = useRouter()

const formSchema = z.object({
  tenantIdentifier: z.string().min(1),
  email: z.string().email(),
  password: z.string().min(1),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    tenantIdentifier: "",
    email: "",
    password: "",
  },
})

const userInactiveAlertRef = ref<InstanceType<
  typeof UserInactiveAlert
> | null>(null)

const onFormElementSubmit = handleSubmit(async (values) => {
  try {
    await logInBasic(values)

    router.push({
      name: "home",
    })
  } catch (error) {
    if (
      error instanceof ApiError &&
      error.code === "user-inactive"
    ) {
      if (userInactiveAlertRef.value !== null) {
        userInactiveAlertRef.value.reveal()
      } else {
        toast.error("User Inactive")
      }
    } else {
      toast.error(
        "Failed to log in. Please check your username and password are correct."
      )
    }
  }
})
</script>
